import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ConsoleInput as MainInput, ConsoleLabel as MainLabel, FieldError } from '../../styles/common/input.styled';
import { Button } from '../../styles/common/Button.styled';
import Modal from '../common/Modal';
import { updateAudioFile, AudioFileResponse } from '../../api/audio';
import toast from 'react-hot-toast';

interface AudioUpdateModalProps {
  audio: AudioFileResponse;
  onClose: () => void;
  onSuccess: () => void;
}

const FormGroup = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const AudioUpdateModal: React.FC<AudioUpdateModalProps> = ({ audio, onClose, onSuccess }) => {
  const [name, setName] = useState(audio.name);
  const [isLoading, setIsLoading] = useState(false);
  const [fieldError, setFieldError] = useState('');

  useEffect(() => {
    setName(audio.name);
  }, [audio]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
      setFieldError('음원 명칭을 입력해 주세요.');
      toast.error('음원 명칭을 입력해 주세요.');
      return;
    }

    if (name === audio.name) {
      onClose();
      return;
    }

    setIsLoading(true);
    try {
      await updateAudioFile(audio.id, { name });
      toast.success('음원 명칭이 수정되었습니다.');
      onSuccess();
      onClose();
    } catch (error) {
      toast.error('명칭 수정에 실패했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal title="음원 명칭 수정" onClose={onClose} width={420} historyMode="none" footer={<><Button $variant="secondary" onClick={onClose}>취소</Button><Button type="submit" form="audio-update-form" disabled={isLoading}>{isLoading ? '처리 중...' : '저장'}</Button></>}>
        <form id="audio-update-form" onSubmit={handleSubmit}>

          <FormGroup>
            <MainLabel htmlFor="audio-update-form-name">음원 명칭</MainLabel>
            <MainInput aria-invalid={Boolean(fieldError)} aria-describedby={fieldError ? "audio-update-form-name-error" : undefined} id="audio-update-form-name"
              type="text"
              value={name}
              onChange={(e) => { setName(e.target.value); setFieldError(''); }}
              placeholder="음원 명칭을 입력하세요"
              autoFocus
            />
            {fieldError && <FieldError id="audio-update-form-name-error">{fieldError}</FieldError>}
          </FormGroup>


        </form>
    </Modal>
  );
};

export default AudioUpdateModal;
